export default __webpack_public_path__ + "static/media/3.b10f9d81.JPG";